import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import WarningIcon from "@mui/icons-material/Warning";

export default function Terms() {
  const year = new Date().getFullYear();

  return (
    <Box component="main" sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            Terms & Conditions — FentrixBank
          </Typography>

          <Typography variant="subtitle2" color="text.secondary">
            Last Updated: {year}
          </Typography>

          <Typography>
            These Terms & Conditions govern your access to and use of FentrixBank’s
            digital banking services (the "Services"). By using the Services you
            agree to comply with these Terms.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            1. Eligibility
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary="You must be 18 years or older (or legal age in your jurisdiction)." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary="You must provide accurate information and comply with KYC requirements." />
            </ListItem>
          </List>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            2. Account Responsibilities
          </Typography>

          <Typography>
            You are responsible for maintaining the confidentiality of credentials,
            notifying us immediately of suspected account compromise, and for any
            activity performed using your account.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            3. Financial Services & Disclaimers
          </Typography>

          <Typography>
            FentrixBank provides storage, payment facilitation, and related financial
            services. We do not guarantee investment returns unless explicitly stated.
            Fees, limits, and service availability may change; we will notify you
            where required by law.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            4. Prohibited Conduct
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <WarningIcon />
              </ListItemIcon>
              <ListItemText primary="Money laundering, terrorist financing, fraud, and other illegal activities." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <WarningIcon />
              </ListItemIcon>
              <ListItemText primary="Using the platform to send funds for unlawful purposes." />
            </ListItem>
          </List>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            5. Suspension, Termination & Liability
          </Typography>

          <Typography>
            We may suspend or close accounts that breach these Terms or where required
            for legal or security reasons. To the extent permitted by law, our liability
            is limited; we are not responsible for losses caused by user error,
            unauthorized access resulting from weak credentials, or market losses from
            investment products.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            6. Disputes & Governing Law
          </Typography>

          <Typography>
            These Terms are governed by applicable laws and regulations. For disputes,
            we encourage first contacting Support; unresolved disputes may be subject
            to arbitration where permitted.
          </Typography>

          <Divider />

          <Typography variant="body2" color="text.secondary">
            For a complete explanation of fees, limits, and service-level commitments,
            review our Support and Security pages, or contact support@fentrixbank.com.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}